module.exports = __webpack_public_path__ + "static/media/yt1.f0d91ad8.png";